const _handlers: Array<() => void> = [];

window.addEventListener("popstate", () => {
  const handler = _handlers.pop();
  if (handler) handler();
});

export const historyBackManager = {
  push(handler: () => void): void {
    history.pushState({}, "");
    _handlers.push(handler);
  },
  remove(handler: () => void): void {
    const i = _handlers.lastIndexOf(handler);
    if (i !== -1) _handlers.splice(i, 1);
  },
};
